import { useCallback, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
  useBroadcastStore,
  setDraftBroadcast,
  TAB_STATUSES,
} from 'store/broadcast';
import { Broadcast } from 'models/broadcast.model';

interface useBroadcastInitializerParams {
  broadcasts: Broadcast[];
}

export const useBroadcastInitializer = ({
  broadcasts,
}: useBroadcastInitializerParams) => {
  const { broadcastId } = useParams<{ broadcastId: string }>();
  const { setActiveTab } = useBroadcastStore((state) => state.actions);

  const initializeBroadcast = useCallback(
    (broadcasts: Broadcast[], targetId: string): void => {
      const currentBroadcast = broadcasts.find(
        (broadcast) => broadcast.id === targetId,
      );

      if (currentBroadcast) {
        setDraftBroadcast(currentBroadcast);
        setActiveTab(
          currentBroadcast.status === 'PUBLISHED'
            ? TAB_STATUSES.PUBLISHED
            : TAB_STATUSES.IN_PROGRESS,
        );
      }
    },
    [setActiveTab],
  );

  useEffect(() => {
    if (!broadcasts.length || !broadcastId) return;

    initializeBroadcast(broadcasts, broadcastId);
  }, [broadcastId, broadcasts, initializeBroadcast]);
};
